// `narrowSymbol` mirrors `useLocalizedCurrencyFormatter` so signed deltas
// render consistently with absolute prices elsewhere.
export function formatSignedCurrency(
  amount: number,
  currency: string,
  locale: string
): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
    signDisplay: 'exceptZero',
  }).format(amount);
}
